import { Check } from '@mui/icons-material';
import { Box, Button, Container, Paper } from '@mui/material';
import { Subheader } from 'components';
import CostItemForm from './CostItemForm';
import EarnItemForm from './EarnItemForm';
import { useNavigate, useParams } from 'react-router-dom';
import useEarnItems from 'hooks/useEarnItems';
import { useEffect } from 'react';
import { useAlerts } from 'hooks';

const EarnItemEdit = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const { showAlertSuccess, showAlertError } = useAlerts();

	const { findEarnItem, earnItem, isLoading, handleChange, updateEarnItem } =
		useEarnItems();

	const handleSaveClick = async () => {
		if (
			earnItem?.name.length > 3 &&
			(earnItem?.coins > 0 || earnItem?.xp > 0)
		) {
			await updateEarnItem(earnItem);
			showAlertSuccess('Earn item updated successfully!');

			return navigate(`/earn-items/${id}`, { replace: true });
		}
		showAlertError(
			'Failed to update earn item. Please check the form for errors.'
		);
	};

	useEffect(() => {
		if (id) findEarnItem(id);
	}, [id]);

	return (
		<>
			<Subheader
				title="Edit Earn Item"
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Save
					</Button>
				]}
			/>

			<Container>
				<Paper>
					<Box p={4}>
						<EarnItemForm earnItem={earnItem} handleChange={handleChange} />
						<Box py={2}>
							<Button
								color="primary"
								variant="contained"
								startIcon={<Check />}
								onClick={handleSaveClick}
							>
								Save
							</Button>
						</Box>
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default EarnItemEdit;
